/* eslint react/jsx-props-no-spreading: 0 */ // --> OFF

import React from "react";
import { Editor } from "primereact/editor";

export default function EditorPR({
  field,
  setFieldValue,
  setFieldTouched,
  value,
  touched,
  validateField,
  isSubmitting,
  isValidating,
  onTextChangeCustom,
  ...props
}) {
  return (
    <Editor
      {...field}
      onTextChange={(e) => {
        setFieldValue(field.name, e.htmlValue);
        setFieldTouched(field.name, true);
        if (
          !isSubmitting &&
          !isValidating &&
          Object.prototype.hasOwnProperty.call(touched, field.name)
        ) {
          validateField(field.name);
        }
        if (onTextChangeCustom) {
          onTextChangeCustom(e);
        }
      }}
      {...props}
    />
  );
}
